import MainRouter from 'components/MainRouter';
import { LanguageProvider } from 'context/LanguageProvider';
import { MuiThemeContext } from 'context/MuiThemeContext';
import { SearchParamsProvider } from 'context/SearchParamsProvider';
import useLocalizedData from 'hooks/useLocalizedData';
import React, {useEffect} from 'react';
import './App.scss';
import APP_LABELS from "components/App/App.labels";

const AppContent = () => {
    const [labels] = useLocalizedData(APP_LABELS);

    useEffect(() => {
        if (labels?.documentTitle) {
            document.title = labels.documentTitle;
        }
    }, [labels?.documentTitle]);

    return <MainRouter />;
};


const App = () => (
  <MuiThemeContext>
    <SearchParamsProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </SearchParamsProvider>
  </MuiThemeContext>
);
export default App;
